<template>
  <div class="error-message">
    <h2>Could not load</h2>
    We could not load this component, please contact support for more
    information.
  </div>
</template>

<script>
export default {
  name: 'ErrorComponent',
}
</script>

<style scoped>
h2 {
  font-family: Lato;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0%;
  color: #4a4a4a;
}
.error-message {
  font-family: Lato;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  color: #6e6e6e;
  height: 100%;
}
</style>
